import { isNullOrUndefined } from "util";

export const IsArrayNullOrUndefinedOrEmpty = (array: Array<any>) => isNullOrUndefined(array) || array.isEmpty();



// WEBPACK FOOTER //
// ./src/utilities/Commons.ts